import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import OurBlogAndInsights from "./sections/OurBlogAndInsights";
import BlogPostsGrid from "./sections/BlogPostsGrid";
import Insights from "./sections/Insights";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <OurBlogAndInsights />
      <Insights />
      <BlogPostsGrid />
      <Footer />
    </div>;
}